import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialGroupLaboratoryFinanceState: Dtos.TrialGroupLaboratoryFinance & IRegistrationFormState = {
    id: null,
    trialGroupLaboratoryId: null,
    trialGroupLaboratory: null,
    overrideFundingEmail: null,
    fundingEmail: null,
    bsbSwift: null,
    accountNumber: null,
    siteCostCentre: null,
    requireInvoiceFromSite: null,
    overridePaymentDetails: null,
    abn: null,
    taxInvoiceName: null,
    quickbooksTaxCodeId: null,
    quickbooksTaxCode: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialGroupLaboratoryFinanceReduxFormState {
    id: IFieldState<number>,
    trialGroupLaboratoryId: IFieldState<number>,
    trialGroupLaboratory: IFieldState<Dtos.TrialGroupLaboratory>,
    quickbooksTaxCodeId: IFieldState<number>,
    overrideFundingEmail: IFieldState<boolean>,
    fundingEmail: IFieldState<string>,
    bsbSwift: IFieldState<string>,
    accountNumber: IFieldState<string>,
    siteCostCentre: IFieldState<string>,
    requireInvoiceFromSite: IFieldState<boolean>,
    overridePaymentDetails: IFieldState<boolean>,
    abn: IFieldState<string>,
    taxInvoiceName: IFieldState<string>,
    quickbooksTaxCode: IFieldState<Dtos.QuickbooksTaxCode>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
